export default __webpack_public_path__ + "static/media/appUpdate.dfb4855d.png";